import uuidFreeStore from "../store/uuidFree";


// Custom hook để sử dụng và cập nhật cấu hình player
const useUuidFree = () => {
    const uuidFree = uuidFreeStore((state) => state.uuidFree);
    const setUuidFree = uuidFreeStore((state) => state.setUuidFree);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        uuidFree,
        setUuidFree
    };
};

export default useUuidFree;
